export default "__VITE_ASSET__Duqi33H3__"